import { cn } from "../lib/utils";

export function TechMappingVisual({
  flows,
  className,
}) {
  return (
    <div className={cn("glass-card p-6", className)}>
      <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            Technology mapping
          </div>
          <h3 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
            RBI Domain → Control → Tech Category → Vendors
          </h3>
        </div>
        <div className="text-sm text-text-tertiary">
          
        </div>
      </div>

      <div className="mt-6 overflow-x-auto">
        <div className="min-w-[960px]">
          <div className="grid grid-cols-12 gap-3">
            <div className="col-span-3 rounded-2xl border border-border-subtle bg-white/5 p-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                Domain
              </div>
              <div className="mt-3 space-y-2">
                {flows.map((f) => (
                  <div key={`${f.domain}-${f.control}`} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-4 text-sm font-semibold text-text-primary">
                    {f.domain}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-span-3 rounded-2xl border border-border-subtle bg-white/5 p-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                Control
              </div>
              <div className="mt-3 space-y-2">
                {flows.map((f) => (
                  <div key={`${f.domain}-${f.control}-c`} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-4 text-sm text-text-secondary">
                    {f.control}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-span-3 rounded-2xl border border-border-subtle bg-white/5 p-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                Technology category
              </div>
              <div className="mt-3 space-y-2">
                {flows.map((f) => (
                  <div key={`${f.domain}-${f.control}-cat`} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-4 text-sm font-semibold text-text-primary">
                    {f.category}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-span-3 rounded-2xl border border-border-subtle bg-white/5 p-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                OEMS
              </div>
              <div className="mt-3 space-y-2">
                {flows.map((f) => (
                  <div key={`${f.domain}-${f.control}-v`} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary">
                    {f.vendors.join(", ")}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-4 text-xs text-text-tertiary">
            
          </div>
        </div>
      </div>
    </div>
  );
}
